import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = ["title"];
import { isExternal } from '@/utils/validate';
import { translate } from '@/i18n';
import { useRoutesStore } from '@/store/modules/routes';
import { defaultOpeneds, openFirstMenu, uniqueOpened } from '@/config';
import { useSettingsStore } from '@/store/modules/settings';
import variables from '@vab/styles/variables/variables.module.scss';

import { useRoute, useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useFullscreen } from '@vueuse/core';
import { nextTick, watchEffect } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const settingsStore = useSettingsStore();
    const {
      theme,
      collapse
    } = storeToRefs(settingsStore);
    const {
      foldSideBar,
      openSideBar,
      toggleCollapse
    } = settingsStore;
    const routesStore = useRoutesStore();
    const {
      isFullscreen
    } = useFullscreen();
    const {
      getTab: tab,
      getTabMenu: tabMenu,
      getActiveMenu: activeMenu,
      getRoutes: routes,
      getPartialRoutes: partialRoutes
    } = storeToRefs(routesStore);
    const handleTabClick = () => {
      console.log('collapse', collapse.value);
      if (collapse.value) {
        toggleCollapse();
      }
      nextTick(() => {
        if (tabMenu.value.children && tabMenu.value.children.length > 0) {
          return;
        }
        if (isExternal(tabMenu.value.path)) {
          window.open(tabMenu.value.path);
          setTimeout(() => {
            router.push('/');
          }, 1000);
        } else if (openFirstMenu) router.push(tabMenu.value.redirect || tabMenu.value);
      });
    };
    watchEffect(() => {
      const foldUnfold = document.querySelector('.fold-unfold');
      if (theme.value.layout === 'column' && route.meta.noColumn) {
        foldSideBar();
        if (foldUnfold) foldUnfold.style = 'display:none';
      } else {
        // openSideBar()
        if (foldUnfold) foldUnfold.style = '';
      }
    });
    return (_ctx, _cache) => {
      const _component_vab_logo = _resolveComponent("vab-logo");
      const _component_vab_icon = _resolveComponent("vab-icon");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_divider = _resolveComponent("el-divider");
      const _component_vab_menu = _resolveComponent("vab-menu");
      const _component_el_menu = _resolveComponent("el-menu");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      return !_unref(isFullscreen) ? (_openBlock(), _createBlock(_component_el_scrollbar, {
        key: 0,
        class: _normalizeClass(["vab-column-bar-container", {
          'is-collapse': _unref(collapse),
          ['vab-column-bar-container-' + _unref(theme).columnStyle]: true
        }])
      }, {
        default: _withCtx(() => [_createVNode(_component_vab_logo), _createVNode(_component_el_tabs, {
          modelValue: _unref(tab).data,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(tab).data = $event),
          "tab-position": "left",
          onTabClick: handleTabClick
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(routes), (item, index) => {
            return _openBlock(), _createBlock(_component_el_tab_pane, {
              key: index + item.name,
              name: item.name
            }, {
              label: _withCtx(() => [_createElementVNode("div", {
                class: _normalizeClass(["vab-column-grid", {
                  ['vab-column-grid-' + _unref(theme).columnStyle]: true
                }]),
                title: _unref(translate)(item.meta.title)
              }, [_createElementVNode("div", null, [item.meta.icon ? (_openBlock(), _createBlock(_component_vab_icon, {
                key: 0,
                icon: item.meta.icon,
                "is-custom-svg": item.meta.isCustomSvg
              }, null, 8, ["icon", "is-custom-svg"])) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(_unref(translate)(item.meta.title)), 1)])], 10, _hoisted_1)]),
              _: 2
            }, 1032, ["name"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_el_menu, {
          "background-color": _unref(variables)['column-second-menu-background'],
          "default-active": _unref(activeMenu).data,
          "default-openeds": _unref(defaultOpeneds),
          mode: "vertical",
          "unique-opened": _unref(uniqueOpened)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_divider, null, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(translate)(_unref(tabMenu) ? _unref(tabMenu).meta.title : _unref(tabMenu))), 1)]),
            _: 1
          }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(partialRoutes), item => {
            return _openBlock(), _createElementBlock(_Fragment, {
              key: item.path
            }, [!item.meta.hidden ? (_openBlock(), _createBlock(_component_vab_menu, {
              key: 0,
              item: item
            }, null, 8, ["item"])) : _createCommentVNode("", true)], 64);
          }), 128))]),
          _: 1
        }, 8, ["background-color", "default-active", "default-openeds", "unique-opened"])]),
        _: 1
      }, 8, ["class"])) : _createCommentVNode("", true);
    };
  }
});